import React, { useState } from "react";
import Base from "./Admin_Base";
import { Breadcrumbs } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Link from "@mui/material/Link";
import Swal from "sweetalert2";
import CircularProgress from "@mui/material/CircularProgress";

const AdminChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  return (
    <Base>
      <div className="pt-3 mt-5 addarea_labels pr-3">
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link
            underline="hover"
            key="1"
            color="inherit"
            href="/admin/dashboard"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Dashboard
          </Link>
          <Link
            underline="hover"
            key="3"
            color="inherit"
            href="/admin/admin_changepassword"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Change Password
          </Link>
        </Breadcrumbs>
      </div>

      <div className="pt-3">
        <h2 className="text-center fw-bold fs-1 main_heading">
          Change Password
        </h2>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <hr style={{ width: "80%" }} />
        </div>
        <form>
          <div className="form-group pt-3" style={{ padding: "0 20px " }}>
            <div className="row pb-3">
              <div
                className="col-sm-3"
                style={{ display: "flex", justifyContent: "end" }}
              >
                <label
                  htmlFor="oldPassword"
                  className="col-sm-6 col-form-label fw-bold"
                >
                  Old Password*
                </label>
              </div>
              <div className="col-sm-7">
                <input
                  type="password"
                  id="oldPassword"
                  value={oldPassword}
                  className="form-control"
                  onChange={(e) => setOldPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row pb-3">
              <div
                className="col-sm-3"
                style={{ display: "flex", justifyContent: "end" }}
              >
                <label
                  htmlFor="newPassword"
                  className="col-sm-6 col-form-label fw-bold"
                >
                  New Password*
                </label>
              </div>
              <div className="col-sm-7">
                <input
                  type="password"
                  id="newPassword"
                  value={newPassword}
                  className="form-control"
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row pb-3">
              <div
                className="col-sm-3"
                style={{ display: "flex", justifyContent: "end" }}
              >
                <label
                  htmlFor="confirmPassword"
                  className="col-sm-6 col-form-label fw-bold"
                >
                  ConfirmPassword*
                </label>
              </div>
              <div className="col-sm-7">
                <input
                  type="password"
                  id="confirmPassword"
                  value={confirmPassword}
                  className="form-control"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              type="submit"
              style={{
                backgroundColor: "green",
                color: "white",
                border: "none",
                padding: "8px 15px",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
              }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} style={{ color: "white" }} />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </Base>
  );
};

export default AdminChangePassword;
